import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../Core/Store";

interface Settings {
    customerLayout: string;
    machineLayout: string;
    customerLayoutSession: string;
    machineLayoutSession: string;
    saved: boolean;
}

const getInitialSettings = (): Settings => {
    try {
        const savedSettings = localStorage.getItem("settings_serviceview");
        if (savedSettings) {
            const parsedSettings = JSON.parse(savedSettings) as Settings;
            let newSettings: any = {
                customerLayoutSession: "Tab Strip",
                machineLayoutSession: "Tab Strip",
            }
            if (parsedSettings != undefined) {
                if (parsedSettings.customerLayout != undefined) {
                    newSettings.customerLayoutSession = parsedSettings.customerLayout;
                    newSettings.customerLayout = parsedSettings.customerLayout;
                }
                if (parsedSettings.machineLayout != undefined) {
                    newSettings.machineLayoutSession = parsedSettings.machineLayout;
                    newSettings.machineLayout = parsedSettings.machineLayout;
                }
            }
           // console.log(newSettings)
            return { ...newSettings, saved: true };
        }
    } catch (error) {
        console.error("Failed to parse settings from localStorage:", error);
    }
    return {
        customerLayout: "Tab Strip",
        machineLayout: "Tab Strip",
        customerLayoutSession: "Tab Strip",
        machineLayoutSession: "Tab Strip",
        saved: false,
    };
};

const initialState: Settings = getInitialSettings();

const settingsSlice = createSlice({
    name: "settings",
    initialState,
    reducers: {
        updateSettings: (state, action: PayloadAction<Settings>) => {
            //console.log(action.payload)
            return action.payload;
        },
    },
});

export const { updateSettings } = settingsSlice.actions;

export const getSettingsSelector = (state: RootState): Settings => state.settings;

export default settingsSlice.reducer;
